/**
 * Adds permanent --revealed class on first hover for .chapter-image-reveal blocks.
 */
(function () {
  'use strict';

  document.addEventListener('mouseover', (e) => {
    const el = e.target.closest && e.target.closest('.chapter-image-reveal');
    if (el && !el.classList.contains('chapter-image-reveal--revealed')) {
      el.classList.add('chapter-image-reveal--revealed');
    }
  }, { passive: true });
})();
